import React, { useEffect, useState } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { AppSnackbar, ConfirmDialog } from '@sierralabs/core-ui';
import { useConfigComponent } from '../hooks/component/useConfigComponent';
import { useDeleteComponent } from '../hooks/component/useDeleteComponent';
import { useSiteContext } from '../SiteContext';
const SiteConfigDeleteComponent = (props) => {
    var _a, _b;
    const { component } = props;
    const [open, setOpen] = useState(false);
    const disabled = Boolean(component.slot) &&
        // disable if only one slot specified
        ((_b = (_a = component.parent) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.filter(c => c.slot === component.slot).length) === 0;
    const { setSiteComponents, setSelectedComponent } = useSiteContext();
    const { removeChild } = useConfigComponent(component.parent || component);
    const { deletedComponent, deletingComponent, deleteError, deleteComponent } = useDeleteComponent(component.id);
    // refresh UI after deleting the component
    useEffect(() => {
        if (deletedComponent) {
            setSiteComponents(components => components.filter(c => c.id !== component.id));
            setSelectedComponent(undefined);
        }
    }, [component.id, deletedComponent, setSelectedComponent, setSiteComponents]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { fullWidth: true, size: 'small', color: 'primary', variant: 'outlined', disabled: disabled || deletingComponent, endIcon: deletingComponent && React.createElement(CircularProgress, { size: 20 }), onClick: () => setOpen(true) }, "Delete Component"),
        React.createElement(ConfirmDialog, { open: open, title: 'Delete Component', message: `Are you sure you want to delete the "${component.name}" component?`, confirmLabel: 'Delete', onCancel: () => setOpen(false), onConfirm: () => {
                setOpen(false);
                if (component.parent) {
                    const index = (component.parent.children || []).findIndex(child => child.id === component.id);
                    if (index > -1) {
                        removeChild(index);
                    }
                }
                else {
                    deleteComponent();
                }
            } }),
        deleteError && (React.createElement(AppSnackbar, { open: true, severity: 'error' }, deleteError.message))));
};
export default SiteConfigDeleteComponent;
//# sourceMappingURL=SiteConfigDeleteComponent.js.map